import { ReactComponent } from './number-5-xl.svg';
export const Number5IconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-5-xl.js.map